import { LOADING } from '../actionTypes'
import { getNamespace } from '../../utils/util'

interface LoadingState {
  app: boolean
  datacenter: boolean
  authmanage: boolean
  usermanage: boolean
  datacentermap: boolean
  [name: string]: boolean
}
const initState: LoadingState = {
  app: false,
  datacenter: false,
  authmanage: false,
  usermanage: false,
  datacentermap: false,
}
export default (state = initState, action: Action) => {
  switch (action.type) {
    case LOADING.SHOWLOADING:
      return {
        ...state,
        [getNamespace(action.payload?.type)]: true,
      }
    case LOADING.HIDELOADING:
      return {
        ...state,
        [getNamespace(action.payload?.type)]: false,
      }
    default:
      return state
  }
}
